import stylesheet from './GridCol.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

const BREAKPOINTS = ['md', 'lg', 'xl', 'xxl'] as const;

export class NXTGridCol extends CustomComponent {
    static observedAttributes = [
        'columns', ...BREAKPOINTS.map((bp) => `columns-${bp}`),
        'offset', ...BREAKPOINTS.map((bp) => `offset-${bp}`),
    ];

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    applySpanClasses() {
        for (const existing of Array.from(this.classList)) {
            if (existing.startsWith('col-') || existing.startsWith('offset-')) {
                this.classList.remove(existing);
            }
        }
        const base = this.getAttribute('columns');
        if (base) {
            this.classList.add(`col-${base}`);
        }
        for (const breakpoint of BREAKPOINTS) {
            const value = this.getAttribute(`columns-${breakpoint}`);
            if (value) {
                this.classList.add(`col-${breakpoint}-${value}`);
            }
        }

        const baseOffset = this.getAttribute('offset');
        if (baseOffset) {
            this.classList.add(`offset-${baseOffset}`);
        }
        for (const breakpoint of BREAKPOINTS) {
            const value = this.getAttribute(`offset-${breakpoint}`);
            if (value) {
                this.classList.add(`offset-${breakpoint}-${value}`);
            }
        }
    }

    // noinspection JSUnusedGlobalSymbols
    attributeChangedCallback() {
        this.applySpanClasses();
    }

    render() {
        this.applySpanClasses();
        const col = document.createElement('div');
        col.classList.add('grid-col');
        col.innerHTML = `<slot></slot>`;
        return col;
    }
}

customElements.define('nxt-grid-col', NXTGridCol);
